<template>
  <v-card class="mt-2">
    <v-toolbar
      dense
      color="white"
      flat
    >
      <v-toolbar-title>
        <v-icon>mdi-file-document-outline</v-icon>
        פריטים
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        @click="add"
        text
        color="primary"
      >
        <v-icon class="me-2">mdi-plus</v-icon>
        הוספת פריט
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text>
      <v-progress-linear
        indeterminate
        height="2"
        v-if="fetching"
      ></v-progress-linear>
      <template v-else-if="items.length">
        <v-data-table
          :headers="headers"
          :items="items"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-start">{{ orderItemTypeById(item.type) }}</td>
              <td class="text-start">{{ additionalItemInfo(item) }}</td>
              <td class="text-start">
                <v-btn
                  icon
                  small
                  text
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon
                    icon
                    small
                  >mdi-pencil</v-icon>
                </v-btn>
              </td>
              <td class="text-start">
                <v-btn
                  icon
                  small
                  text
                  color="error"
                  @click="removeItem(item)"
                >
                  <v-icon
                    icon
                    small
                  >mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-alert
        :value="true"
        color="white"
        class="ma-0 grey--text"
        v-else
      >
        אין פריטים
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      removing: [],
      fetching: false,
      headers: [
        { text: "סוג פריט", align: "right", value: "type" },
        { text: "תיאור", align: "right", value: "", sortable: false },
        { text: "עריכה", align: "right", value: "edit", sortable: false },
        { text: "מחיקה", align: "right", value: "remove", sortable: false }
      ]
    };
  },
  computed: {
    items() {
      return Object.values(this.$store.state.entities.orderItems)
        .filter(item => {
          return item.order && item.order === this.order._id;
        });
    }
  },
  props: ["order", "add"],
  watch: {},
  mounted() {
    this.fetch();
  },
  methods: {
    format,
    fetch() {
      this.fetching = true;
      let query = {
        order: this.order._id
      };
      this.$store
        .dispatch("API_GET", {
          url: "/order-items",
          entityType: "orderItems",
          schema: "orderItemListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    orderItemTypeById(id) {
      if (id) {
        let item = this.$store.state.entities.orderItemTypes[id];
        if (item) {
          return item.title;
        }
      }
    },
    additionalItemInfo(item) {
      let orderItemType = this.$store.state.entities.orderItemTypes[item.type];
      let deviceType, returnType, receiveType, addon;
      switch (orderItemType.key) {
        case 'DEVICE':
          deviceType = this.$store.state.entities.deviceTypes[item.deviceType];
          return deviceType ? deviceType.title : 'לא ידוע';
        case 'RETURN':
          returnType = this.$store.state.entities.returnTypes[item.returnType];
          return returnType ? returnType.title : 'לא ידוע';
        case 'RECEIVE':
          receiveType = this.$store.state.entities.receiveTypes[item.receiveType];
          return receiveType ? receiveType.title : 'לא ידוע';
        case 'ADDON':
          addon = this.$store.state.entities.addons[item.addon];
          return addon ? addon.title : 'לא ידוע';
        case 'OTHER':
          return item.title || '';
        default:
          return ''
      }
    },
    editItem(item) {
      let resource = this.$store.state.resources.orderItem;
      this.editEntity(item, resource);
    },
    removeItem(item) {
      let resource = this.$store.state.resources.orderItem;
      this.removeEntity(item, resource);
    }
  },
  components: {},
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>